import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const updateScenarioRuleSet = api(async function updateScenarioRuleSet({ scenarioId, data }) {
    return mutate(
        gql`
            mutation UpdateScenarioRuleSet($scenarioId: String!, $data: RuleSetInput!) {
                updateScenarioRuleSet(scenarioId: $scenarioId, data: $data)
            }
        `,
        { scenarioId, data },
        { returns: "updateScenarioRuleSet" }
    )
})
